var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import fetch from 'isomorphic-fetch';
import xss from 'xss';
import moment from 'moment';

import Wrapper from './components/wrapper';
import MessageList from './components/message-list';
import TextBox from './components/text-box';
import { isEmail } from './utils';

var ChatBot = function (_Component) {
  _inherits(ChatBot, _Component);

  function ChatBot(props) {
    _classCallCheck(this, ChatBot);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      minConfidence: _this.props.minConfidence,
      insertingCredentials: false,
      showRequestOperatorButton: false,
      credentials: {}
    };

    _this.addMessage = _this.props.addMessage;
    _this.switchChat = _this.props.switchChat;

    _this.myxss = new xss.FilterXSS({
      whiteList: {
        a: ['href']
      }
    });
    return _this;
  }

  ChatBot.prototype.componentDidMount = function componentDidMount() {
    if (this.props.messages.length === 0) this.addMessage({
      text: 'Ciao sono ' + this.props.chatbotName + ' e puoi chiedermi quello che vuoi!',
      user: 'BOT',
      name: this.props.chatbotName
    });
  };

  ChatBot.prototype.handleQuestion = function handleQuestion(e) {
    if (e.key === 'Enter') {
      if (e.target.value === '') {
        return;
      }

      var question = this.myxss.process(e.target.value);
      this.addMessage({ text: question, user: 'CUSTOMER' });

      e.target.value = '';

      if (this.checkKeyword(question) && this.isOperatorAvailable()) this.handleRequestOperator();else if (this.state.insertingCredentials) this.handleCredentials(question);else this.handleBotQuestion(question);
    }
  };

  ChatBot.prototype.checkKeyword = function checkKeyword(word) {
    var keywords = this.props.keywords;

    return keywords && keywords.includes(word);
  };

  ChatBot.prototype.handleBotQuestion = function handleBotQuestion(question) {
    var _this2 = this;

    var _props = this.props,
        endpoint = _props.endpoint,
        subKey = _props.subKey,
        emailAddress = _props.emailAddress,
        minConfidence = _props.minConfidence;


    this.setState({ loading: true });

    fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({ question: question }),
      headers: {
        'Ocp-Apim-Subscription-Key': subKey,
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.json();
    }).then(function (json) {
      _this2.setState({ loading: false });

      if (!json.answers) {
        _this2.addMessage({
          text: 'È sucesso un errore imprevisto. Riprova tra qualche minuto!',
          user: 'ERROR'
        });
      } else if (json.answers[0].score >= minConfidence) {
        _this2.addMessage({
          text: json.answers[0].answer,
          user: 'BOT',
          name: _this2.props.chatbotName
        });
      } else if (_this2.props.operatorChatAvailable) {
        var operatorChatStillAvailable = moment().isBefore(_this2.props.operatorChatAvailableUntil);

        if (_this2.props.operatorChatAvailableNow && operatorChatStillAvailable) {
          var action = {
            onClick: _this2.handleRequestOperator.bind(_this2),
            text: 'Chatta con un operatore'
          };
          _this2.addMessage({
            text: 'Non riusciamo a rispondere alla tua domanda! Vuoi essere messo in contatto con un operatore?',
            user: 'BOT',
            action: action,
            name: _this2.props.chatbotName
          });
          _this2.setState({ showRequestOperatorButton: true });
        } else {
          _this2.addMessage({
            text: 'Non riusciamo a rispondere alla tua domanda! Puoi parlare con un operatore tutti i giorni, dal Luned\xEC al Venerd\xEC, esclusi i festivi, dalle 9:00 alle 18:00. Se vuoi contattarci in orari e giorni diversi <a href=\'mailto:' + emailAddress + '\'>scrivici un\'email.</a>',
            user: 'ERROR'
          });
        }
      } else if (_this2.props.onChatbotFail) {
        _this2.addMessage({
          text: _this2.props.onChatbotFailMessage,
          action: {
            text: _this2.props.onChatbotFailButtonMessage,
            onClick: function onClick() {
              return _this2.props.onChatbotFail(question);
            }
          }
        });
      } else {
        _this2.addMessage({
          text: 'Non riusciamo a rispondere alla tua domanda! <a href=\'mailto:' + emailAddress + '\'>Scrivici una email.</a>',
          user: 'ERROR'
        });
      }
    });
  };

  ChatBot.prototype.persistState = function persistState(newState, doRequestCredentials) {
    var _this3 = this;

    this.setState(function (prevState) {
      var newerState = _extends({}, prevState || {}, newState);
      sessionStorage.setItem('chatState', JSON.stringify(newerState));
      if (!!doRequestCredentials) {
        _this3.requestCredentials(newerState);
      }
      return newerState;
    });
  };

  ChatBot.prototype.handleCredentials = function handleCredentials(credential) {
    var credentials = this.state.credentials;

    var insertingCredentials = true;

    if (!credentials.email) {
      if (isEmail(credential)) {
        credentials.email = credential;
      } else {
        this.addMessage({
          text: 'La mail inserita non è valida',
          user: 'ERROR'
        });
      }
      this.requestCredentials();
    } else if (!credentials.name) {
      credentials.name = credential;
      this.requestCredentials();
    } else if (!credentials.surname) {
      credentials.surname = credential;
      this.requestCredentials();
    } else {
      var answer = credential.toLowerCase()[0];
      if (answer === 's') {
        insertingCredentials = false;
        this.switchChat(credentials);
      } else {
        credentials.name = null;
        credentials.surname = null;
        credentials.email = null;
        this.requestCredentials();
      }
    }

    var newState = {
      loading: false,
      insertingCredentials: insertingCredentials,
      credentials: credentials
    };

    this.persistState(newState);
  };

  ChatBot.prototype.handleRequestOperator = function handleRequestOperator() {
    var _this4 = this;

    if (this.props.onChatbotFail) {
      this.addMessage({
        text: this.props.onChatbotFailMessage,
        action: {
          text: this.props.onChatbotFailButtonMessage,
          onClick: function onClick() {
            return _this4.props.onChatbotFail();
          }
        }
      });
    } else {
      var chatState = JSON.parse(sessionStorage.getItem('chatState') || '{}');
      if (!chatState.credentials) {
        this.setState({
          insertingCredentials: true,
          showRequestOperatorButton: false
        });
        this.requestCredentials();
      } else {
        this.persistState(chatState, true);
      }
    }
  };

  ChatBot.prototype.isOperatorAvailable = function isOperatorAvailable() {
    if (!this.props.operatorChatAvailable) return false;

    var operatorChatStillAvailable = moment().isBefore(this.props.operatorChatAvailableUntil);

    return this.props.operatorChatAvailableNow && operatorChatStillAvailable;
  };

  ChatBot.prototype.requestCredentials = function requestCredentials(state) {
    var _this5 = this;

    var _ref = !!state ? state : this.state,
        credentials = _ref.credentials;

    var message = {
      user: 'BOT',
      name: this.props.chatbotName
    };

    if (!credentials.email) {
      message.text = 'Inserisci la tua email';
    } else if (!credentials.name) {
      message.text = 'Inserisci il tuo nome';
    } else if (!credentials.surname) {
      message.text = 'Inserisci il tuo cognome';
    } else {
      message.text = '\nRiepilogo informazioni\n\n> **Nome:**\n>\n> ' + credentials.name + '\n>\n> **Cognome:**\n>\n> ' + credentials.surname + '\n>\n> **Email:**\n>\n> ' + credentials.email + '\n\n  vuoi continuare?\n';

      message.actions = [{
        text: 'Si',
        onClick: function onClick() {
          _this5.setState({
            insertingCredentials: false
          });
          _this5.switchChat(credentials);
        }
      }, {
        text: 'No',
        onClick: function onClick() {
          _this5.setState({
            credentials: {}
          });
          _this5.requestCredentials({ credentials: {} });
        }
      }];
    }

    this.addMessage(message);
  };

  ChatBot.prototype.render = function render() {
    return React.createElement(
      Wrapper,
      null,
      this.props.children,
      React.createElement(MessageList, {
        messages: this.props.messages,
        loading: this.state.loading
      }),
      React.createElement(TextBox, {
        loading: this.state.loading,
        onKeyPress: this.handleQuestion.bind(this)
      })
    );
  };

  return ChatBot;
}(Component);

export { ChatBot as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/chat-bot.js
// module id = 756
// module chunks = 1